import { apiPHP } from "../services/api";
import { message } from 'antd';

export interface IEmail {
    email: string;
}

export async function sendEmail (data: IEmail): Promise<boolean> {
    try {
        await apiPHP.get(`/users/${data.email}/redefinir_senha`);
        message.success("Um e-mail foi enviado para o endereço: "+ data.email+"!");
        return true;
    } catch (error) {
        message.error('Ocorreu um erro, tente novamente!', 3);
        return false;   
    }  
}